<template>
  <div>
    <CrudList
      title="Trabajos"
      storeName="Jobs"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
    >
      <template v-slot:icon="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.icon">
              <img :src="item.icon" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>

      <template v-slot:new_speciality="{item}">
      <v-btn
          class="my-2"
          color="primary"
          @click="$router.push('/admin/jobs/' + item.id + '/specialities')"
      >Especialidades
      </v-btn>
    </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
